'use client';

import React from 'react';

import { ArrowRightIcon } from 'lucide-react';
import { motion } from 'motion/react';
import { useTranslations } from 'next-intl';

import Link from 'next/link';

import { Button } from '../ui/button';

export const HeroSection = () => {
    const t = useTranslations();
    return (
        <section className="relative overflow-hidden min-h-[88vh] flex items-center" aria-label="Hero">
            {/* Background image */}
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: "url('/img/hero-bg.webp')",
                    backgroundColor: 'var(--secondary)',
                    backgroundPositionY: '20%',
                }}
                aria-hidden="true"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40" aria-hidden="true" />

            {/* Hero content */}
            <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
                <div className="max-w-3xl">
                    <motion.h1
                        className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-16.5 text-balance mb-6"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.6 }}
                        transition={{ duration: 0.6, ease: 'easeOut' }}
                    >
                        {t('Hero.garantiya')}{' '}
                        <span className="text-primary font-serif font-medium">{t('Hero.bezuprechnogo')}</span>{' '}
                        {t('Hero.kachestva')}
                    </motion.h1>

                    <motion.p
                        className="text-lg sm:text-xl text-white/70 leading-relaxed mb-10 max-w-2xl text-pretty"
                        initial={{ opacity: 0, y: 18 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.6 }}
                        transition={{ duration: 0.6, delay: 0.1, ease: 'easeOut' }}
                    >
                        {t('Hero.myStrogoOceni')}
                    </motion.p>

                    <motion.div
                        className="flex flex-wrap items-center gap-4"
                        initial={{ opacity: 0, y: 18 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.6 }}
                        transition={{ duration: 0.6, delay: 0.1, ease: 'easeOut' }}
                    >
                        <Link href="/whitelist">
                            <Button className="group">
                                {t('NavItems.belyiSpisok')}
                                <ArrowRightIcon
                                    className="h-4 w-4 group-hover:translate-x-[2px] transition-transform duration-300"
                                    aria-hidden="true"
                                />
                            </Button>
                        </Link>
                        <Link href="/about">
                            <Button
                                variant={'outline'}
                                className="border-white text-white bg-transparent hover:bg-white/10"
                            >
                                {t('NavItems.oNas')}
                            </Button>
                        </Link>
                    </motion.div>
                </div>
            </div>
            {/* Bottom fade */}
            <div
                className="absolute bottom-0 left-0 right-0 h-12 sm:h-24 bg-gradient-to-t from-background to-transparent"
                aria-hidden="true"
            />
        </section>
    );
};

